var Ractive = require('ractive');
var component = module;

	component.exports = {
		onrender: function (options) {
			var self = this;

			if (Client.isEcho()) console.log('Application started!');
			var Session = self.get('Session');
			Session = Client.getMerge(Session, Client.getCache('Session'));
			self.set('Session', Session);


			//Client.setSessionAll(Session);

			self.on('doUrl', function (iUrl) {
				var fUrl = (iUrl) ? iUrl : Client.getUrl();
				if (Client.isEcho()) console.log('Navigate Url:', fUrl);
				self.set('UrlLink', fUrl.Url);

				if (Global && Global.Session && !Global.Session.Status) {
					self.set('IsUser', false);
					Client.setDisplay({ Id: 'list', Frame: "login" });
					return;
				}
				self.set('IsUser', true);
				self.set('IsInfo', (Global.Session.InfoKey));
				//self.set('IsInfo', true);

				if (fUrl && (fUrl.Hash)) {
					let fHash = fUrl.Hash;
					switch (fHash.toLowerCase()) {
						case "list":
							if (fUrl.UID) {
								let fMenu = ("menu" + fUrl.UID).toLowerCase();
								if (Ractive.components[fMenu]) {
									fHash = fMenu;
								}
							} else {
								fHash = '404';
							}
							break;
					}
					Client.setDisplay({ Id: 'list', Frame: fHash });
				} else {
					if (Global && Global.Config && Global.Config.DisplayHome) {
						Client.setDisplay({ Id: 'list', Frame: Global.Config.DisplayHome });
					} else {
						Client.setDisplay({ Id: 'list', Frame: '#' });
					}
				}
			});
			/*self.on('cmdRefresh', function (iFrame) {
				if(sess = Client.getSession()){
					if(self.isEcho()) console.log('Session found:', sess);
					if(!sess.Status){
						//self.setDisplay('Display-Access');
					}else{
						self.set('logOff', false);
						self.set('Session',  Client.getMerge({}, self.get('Session'), sess));
					}
				}else{
					self.setDisplay('Logoff');
				}

				if(iFrame) {
					self.cmdRefresh();
				}
			});*/
			Client.setUrlChange(function () {
				self.fire('doUrl');
			}, true);
		},
		data: function () {
			return {
				UrlLink: "",
				Session: {},
				IsUser: false,
				IsInfo: false,
				Lng: SiteLng
			}
		}
	}

component.exports.template = {v:4,t:[{t:4,f:[{t:4,f:[{p:[3,1,34],t:7,e:"div",m:[{n:"id",f:"loader",t:13}],f:[{p:[4,2,54],t:7,e:"img",m:[{n:"src",f:"/res/images/media/loader.svg",t:13},{n:"alt",f:"",t:13}]}]}," ",{p:[6,1,111],t:7,e:"div",m:[{n:"class",f:"page",t:13}],f:[{p:[7,2,132],t:7,e:"Part-Head"}," ",{p:[9,2,160],t:7,e:"aside",m:[{n:"class",f:"app-sidebar sticky",t:13},{n:"id",f:"sidebar",t:13}],f:[{p:[10,3,211],t:7,e:"div",m:[{n:"class",f:"main-sidebar-header",t:13}],f:[{p:[11,4,249],t:7,e:"a",m:[{n:"class",f:"header-logo",t:13},{n:"href",f:"#pocetna",t:13}],f:[{p:[12,5,294],t:7,e:"img",m:[{n:"src",f:"/res/images/brand-logos/desktop-logo.png",t:13},{n:"alt",f:"logo",t:13},{n:"class",f:"desktop-logo",t:13}]}," ",{p:[13,5,384],t:7,e:"img",m:[{n:"src",f:"/res/images/brand-logos/toggle-dark.png",t:13},{n:"alt",f:"logo",t:13},{n:"class",f:"toggle-dark",t:13}]}," ",{p:[14,5,472],t:7,e:"img",m:[{n:"src",f:"/res/images/brand-logos/desktop-dark.png",t:13},{n:"alt",f:"logo",t:13},{n:"class",f:"desktop-dark",t:13}]}," ",{p:[15,5,562],t:7,e:"img",m:[{n:"src",f:"/res/images/brand-logos/toggle-logo.png",t:13},{n:"alt",f:"logo",t:13},{n:"class",f:"toggle-logo",t:13}]}," ",{p:[16,5,650],t:7,e:"img",m:[{n:"src",f:"/res/images/brand-logos/toggle-white.png",t:13},{n:"alt",f:"logo",t:13},{n:"class",f:"toggle-white",t:13}]}," ",{p:[17,5,740],t:7,e:"img",m:[{n:"src",f:"/res/images/brand-logos/desktop-white.png",t:13},{n:"alt",f:"logo",t:13},{n:"class",f:"desktop-white",t:13}]}]}]}," ",{p:[20,3,849],t:7,e:"Part-MenuLeft",m:[{n:"UrlLink",f:[{t:2,r:"UrlLink",p:[20,27,873]}],t:13}]}]}," ",{p:[22,2,916],t:7,e:"div",m:[{n:"class",f:"main-content app-content",t:13},{n:"id",f:"list",t:13}],f:[{p:[23,3,968],t:7,e:"div",m:[{n:"class",f:"d-flex justify-content-center mb-4",t:13}],f:[{p:[24,4,1022],t:7,e:"div",m:[{n:"class",f:"spinner-border",t:13},{n:"role",f:"status",t:13}],f:[{p:[25,5,1070],t:7,e:"span",m:[{n:"class",f:"visually-hidden",t:13}],f:["Loading..."]}]}]}]}]}," ",{p:[32,1,1163],t:7,e:"div",m:[{n:"class",f:"scrollToTop",t:13}],f:[{p:[33,2,1191],t:7,e:"span",m:[{n:"class",f:"arrow",t:13}],f:[{p:[33,22,1211],t:7,e:"i",m:[{n:"class",f:"ti ti-arrow-narrow-up fs-20",t:13}]}]}]}," ",{p:[35,1,1271],t:7,e:"div",m:[{n:"id",f:"responsive-overlay",t:13}]}," ",{p:[37,1,1310],t:7,e:"script",m:[{n:"src",f:"/res/js/defaultmenu.min.js",t:13}]}," ",{p:[38,1,1362],t:7,e:"script",m:[{n:"src",f:"/res/js/sticky.js",t:13}]}," ",{p:[39,1,1405],t:7,e:"script",m:[{n:"src",f:"/res/js/simplebar.js",t:13}]}],n:50,r:"IsInfo",p:[2,1,17]},{t:4,n:51,f:[{p:[41,1,1461],t:7,e:"div",m:[{n:"class",f:"container page",t:13}],f:[{p:[42,2,1492],t:7,e:"div",m:[{n:"class",f:"row justify-content-center align-items-center authentication authentication-basic h-100",t:13}],f:[{p:[43,3,1597],t:7,e:"div",m:[{n:"class",f:"col-xxl-4 col-xl-4 col-lg-6 col-md-8 col-sm-10 col-12",t:13}],f:[{p:[44,4,1669],t:7,e:"div",m:[{n:"class",f:"card custom-card my-4",t:13}],f:[{p:[45,5,1710],t:7,e:"div",m:[{n:"class",f:"card-body",t:13}],f:[{p:[46,6,1740],t:7,e:"Element-InfoSelect"}]}]}]}]}]}],l:1}],n:50,r:"IsUser",p:[1,1,0]},{t:4,n:51,f:[{p:[54,1,1852],t:7,e:"Element-NoAuth"}],l:1}]};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Display/Root.html
// module id = 25
// module chunks = 0